/**
 * Torso outfit textures: alien-mythic-1
 */
export function drawTorso_seraph_male(ctx, size, options = {}) {
  const mainColor = options.shirtColor;
  // 31. ÁO CHOÀNG TU SĨ ÁNH SÁNG VẠT DÀI THÁNH QUANG (AETHELGARD - MALE)
  ctx.fillStyle = mainColor || '#fef9c3';
  ctx.fillRect(0, 0, size, size);

  // Cổ áo thánh quang
  ctx.fillStyle = options.skinColor || '#fef08a';
  ctx.beginPath();
  ctx.moveTo(size * 0.35, 0);
  ctx.lineTo(size * 0.5, size * 0.16);
  ctx.lineTo(size * 0.65, 0);
  ctx.closePath();
  ctx.fill();

  // Nẹp viền vàng kim vạt áo chữ Y
  ctx.strokeStyle = '#eab308';
  ctx.lineWidth = size * 0.025;
  ctx.beginPath();
  ctx.moveTo(size * 0.35, 0);
  ctx.lineTo(size * 0.5, size * 0.16);
  ctx.lineTo(size * 0.5, size * 0.65);
  ctx.stroke();
  ctx.beginPath();
  ctx.moveTo(size * 0.65, 0);
  ctx.lineTo(size * 0.5, size * 0.16);
  ctx.stroke();

  // Biểu tượng thánh quang mặt trời ở ngực
  ctx.fillStyle = '#facc15';
  ctx.beginPath();
  ctx.arc(size * 0.5, size * 0.35, size * 0.06, 0, Math.PI * 2);
  ctx.fill();
  ctx.fillStyle = '#ffffff';
  ctx.beginPath();
  ctx.arc(size * 0.5, size * 0.35, size * 0.025, 0, Math.PI * 2);
  ctx.fill();

  // Đai thắt lưng vàng kim
  ctx.fillStyle = '#ca8a04';
  ctx.fillRect(0, size * 0.65, size, size * 0.1);
  ctx.fillStyle = '#fef08a';
  ctx.fillRect(size * 0.42, size * 0.66, size * 0.16, size * 0.08);
}

export function drawTorso_seraph_female(ctx, size, options = {}) {
  // 32. VÁY LỤA THÁNH QUANG DẠ QUANG THANH THOÁT (AETHELGARD - FEMALE)
  const seraphFGrad = ctx.createLinearGradient(0, 0, 0, size);
  seraphFGrad.addColorStop(0, '#fefce8');
  seraphFGrad.addColorStop(0.5, '#fef08a');
  seraphFGrad.addColorStop(1, '#fde047');
  ctx.fillStyle = seraphFGrad;
  ctx.fillRect(0, 0, size, size);

  // Cổ áo cánh én thanh thoát
  ctx.fillStyle = options.skinColor || '#fef08a';
  ctx.beginPath();
  ctx.ellipse(size * 0.5, 0, size * 0.22, size * 0.14, 0, 0, Math.PI);
  ctx.fill();

  // Tia hào quang thêu chỉ vàng
  ctx.strokeStyle = 'rgba(234, 179, 8, 0.6)';
  ctx.lineWidth = size * 0.015;
  for (let i = -2; i <= 2; i++) {
    ctx.beginPath();
    ctx.moveTo(size * 0.5, size * 0.2);
    ctx.lineTo(size * (0.5 + i * 0.15), size * 0.55);
    ctx.stroke();
  }

  // Đai lụa thắt eo đính ngọc quang học
  ctx.fillStyle = '#eab308';
  ctx.fillRect(0, size * 0.62, size, size * 0.08);
  ctx.fillStyle = '#ffffff';
  ctx.beginPath();
  ctx.arc(size * 0.5, size * 0.66, size * 0.04, 0, Math.PI * 2);
  ctx.fill();
}

export function drawTorso_lithos_male(ctx, size, options = {}) {
  const mainColor = options.shirtColor;
  // 33. ÁO GIÁP PHIẾN ĐÁ CỔ GHÉP ĐAI DA THUỘC RÃNH KHẮC CỔ TỰ (ARCHAEA-RUNE - MALE)
  ctx.fillStyle = mainColor || '#334155';
  ctx.fillRect(0, 0, size, size);

  // Phiến đá ngực ghép 2 mảng lớn
  ctx.fillStyle = '#1e293b';
  ctx.fillRect(size * 0.15, size * 0.15, size * 0.32, size * 0.45);
  ctx.fillRect(size * 0.53, size * 0.15, size * 0.32, size * 0.45);

  // Cổ tự rune phát quang vàng hổ phách trên phiến đá
  ctx.strokeStyle = '#f59e0b';
  ctx.lineWidth = size * 0.02;
  ctx.beginPath();
  ctx.moveTo(size * 0.31, size * 0.25);
  ctx.lineTo(size * 0.31, size * 0.45);
  ctx.moveTo(size * 0.23, size * 0.35);
  ctx.lineTo(size * 0.39, size * 0.35);
  ctx.stroke();

  ctx.beginPath();
  ctx.moveTo(size * 0.69, size * 0.25);
  ctx.lineTo(size * 0.69, size * 0.45);
  ctx.moveTo(size * 0.61, size * 0.3);
  ctx.lineTo(size * 0.77, size * 0.4);
  ctx.stroke();

  // Đai da bò thô đính đinh tán sắt
  ctx.fillStyle = '#0f172a';
  ctx.fillRect(0, size * 0.68, size, size * 0.12);
  [0.2, 0.4, 0.6, 0.8].forEach((xPos) => {
    ctx.fillStyle = '#94a3b8';
    ctx.beginPath();
    ctx.arc(size * xPos, size * 0.74, size * 0.02, 0, Math.PI * 2);
    ctx.fill();
  });
}

export function drawTorso_lithos_female(ctx, size, options = {}) {
  const mainColor = options.shirtColor;
  // 34. ÁO CHOÀNG ĐÁ PHIẾN LỤA THỔ CẨM CỔ TỰ (ARCHAEA-RUNE - FEMALE)
  ctx.fillStyle = mainColor || '#475569';
  ctx.fillRect(0, 0, size, size);

  // Cổ áo chữ V đá phiến
  ctx.fillStyle = options.skinColor || '#64748b';
  ctx.beginPath();
  ctx.moveTo(size * 0.34, 0);
  ctx.lineTo(size * 0.5, size * 0.18);
  ctx.lineTo(size * 0.66, 0);
  ctx.closePath();
  ctx.fill();

  // Dải hoa văn thổ cẩm cổ tự chạy dọc thân
  ctx.fillStyle = '#1e293b';
  ctx.fillRect(size * 0.4, size * 0.18, size * 0.2, size * 0.5);
  ctx.strokeStyle = '#f59e0b';
  ctx.lineWidth = size * 0.015;
  [0.25, 0.35, 0.45, 0.55].forEach((yPos) => {
    ctx.strokeRect(size * 0.44, size * yPos, size * 0.12, size * 0.06);
  });

  // Đai eo đá cự thạch
  ctx.fillStyle = '#334155';
  ctx.fillRect(0, size * 0.68, size, size * 0.08);
  ctx.fillStyle = '#f59e0b';
  ctx.beginPath();
  ctx.arc(size * 0.5, size * 0.72, size * 0.035, 0, Math.PI * 2);
  ctx.fill();
}

export function drawTorso_gem_male(ctx, size, options = {}) {
  const mainColor = options.shirtColor;
  // 35. ÁO GẤM TINH THỂ CẮT GIÁC ĐÍNH THẠCH ANH (KRYSTALIA - MALE)
  ctx.fillStyle = mainColor || '#ea580c';
  ctx.fillRect(0, 0, size, size);

  // Các múi cắt giác tinh thể thạch anh
  ctx.fillStyle = '#c2410c';
  ctx.beginPath();
  ctx.moveTo(size * 0.5, size * 0.1);
  ctx.lineTo(size * 0.8, size * 0.35);
  ctx.lineTo(size * 0.5, size * 0.6);
  ctx.lineTo(size * 0.2, size * 0.35);
  ctx.closePath();
  ctx.fill();

  ctx.strokeStyle = '#fed7aa';
  ctx.lineWidth = size * 0.02;
  ctx.stroke();

  // Viên ngọc tinh thể trung tâm phát quang
  ctx.fillStyle = '#ffedd5';
  ctx.beginPath();
  ctx.arc(size * 0.5, size * 0.35, size * 0.06, 0, Math.PI * 2);
  ctx.fill();

  // Đai thắt lưng tinh thể
  ctx.fillStyle = '#9a3412';
  ctx.fillRect(0, size * 0.68, size, size * 0.1);
  ctx.fillStyle = '#fb923c';
  ctx.fillRect(size * 0.42, size * 0.69, size * 0.16, size * 0.08);
}

export function drawTorso_gem_female(ctx, size, options = {}) {
  // 36. VÁY DẠ HỘI TINH THỂ PHA LÊ CẦU VỒNG (KRYSTALIA - FEMALE)
  const gemFGrad = ctx.createLinearGradient(0, 0, 0, size);
  gemFGrad.addColorStop(0, '#f97316');
  gemFGrad.addColorStop(0.5, '#fb923c');
  gemFGrad.addColorStop(1, '#fdba74');
  ctx.fillStyle = gemFGrad;
  ctx.fillRect(0, 0, size, size);

  // Cổ áo lăng kính pha lê
  ctx.fillStyle = options.skinColor || '#fed7aa';
  ctx.beginPath();
  ctx.moveTo(size * 0.3, 0);
  ctx.lineTo(size * 0.5, size * 0.18);
  ctx.lineTo(size * 0.7, 0);
  ctx.closePath();
  ctx.fill();

  // Múi thêu lấp lánh phản quang
  ctx.strokeStyle = '#ffffff';
  ctx.lineWidth = size * 0.015;
  [0.28, 0.42, 0.56].forEach((yPos) => {
    ctx.beginPath();
    ctx.moveTo(size * 0.25, size * yPos);
    ctx.lineTo(size * 0.5, size * (yPos - 0.05));
    ctx.lineTo(size * 0.75, size * yPos);
    ctx.stroke();
  });

  // Đai eo ngọc pha lê
  ctx.fillStyle = '#ea580c';
  ctx.fillRect(0, size * 0.64, size, size * 0.08);
  ctx.fillStyle = '#ffffff';
  ctx.beginPath();
  ctx.arc(size * 0.5, size * 0.68, size * 0.04, 0, Math.PI * 2);
  ctx.fill();
}

export function drawTorso_mercury_male(ctx, size, options = {}) {
  const mainColor = options.shirtColor;
  // 37. ÁO HỢP KIM MẠ CROM PHẢN QUANG GƯƠNG VẠT ĐỨNG (HYDRARGIS - MALE)
  ctx.fillStyle = mainColor || '#475569';
  ctx.fillRect(0, 0, size, size);

  // Tấm ngực hợp kim mạ crom sáng bóng
  const cromGrad = ctx.createLinearGradient(size * 0.15, 0, size * 0.85, 0);
  cromGrad.addColorStop(0, '#64748b');
  cromGrad.addColorStop(0.5, '#e2e8f0');
  cromGrad.addColorStop(1, '#64748b');
  ctx.fillStyle = cromGrad;
  ctx.fillRect(size * 0.18, size * 0.15, size * 0.64, size * 0.48);

  // Đường rãnh dẫn kim loại lỏng dọc sống áo
  ctx.fillStyle = '#38bdf8';
  ctx.fillRect(size * 0.48, size * 0.15, size * 0.04, size * 0.48);

  // Vạch highlight trắng bóng gương
  ctx.fillStyle = '#ffffff';
  ctx.fillRect(size * 0.22, size * 0.18, size * 0.1, size * 0.03);

  // Đai lưng mạ niken bóng
  ctx.fillStyle = '#334155';
  ctx.fillRect(0, size * 0.68, size, size * 0.1);
  ctx.fillStyle = '#e2e8f0';
  ctx.fillRect(size * 0.4, size * 0.69, size * 0.2, size * 0.08);
}

export function drawTorso_mercury_female(ctx, size, options = {}) {
  // 38. ÁO VÁY KIM LOẠI LỎNG UỐN LƯỢN THANH LỊCH (HYDRARGIS - FEMALE)
  const mercFGrad = ctx.createLinearGradient(0, 0, 0, size);
  mercFGrad.addColorStop(0, '#64748b');
  mercFGrad.addColorStop(0.5, '#94a3b8');
  mercFGrad.addColorStop(1, '#cbd5e1');
  ctx.fillStyle = mercFGrad;
  ctx.fillRect(0, 0, size, size);

  // Cổ áo lượn sóng thủy ngân
  ctx.fillStyle = options.skinColor || '#cbd5e1';
  ctx.beginPath();
  ctx.ellipse(size * 0.5, 0, size * 0.24, size * 0.14, 0, 0, Math.PI);
  ctx.fill();

  // Sóng kim loại lỏng ánh bạc
  ctx.strokeStyle = '#ffffff';
  ctx.lineWidth = size * 0.018;
  [0.26, 0.42, 0.56].forEach((yPos) => {
    ctx.beginPath();
    ctx.moveTo(size * 0.2, size * yPos);
    ctx.bezierCurveTo(size * 0.35, size * (yPos - 0.05), size * 0.65, size * (yPos + 0.05), size * 0.8, size * yPos);
    ctx.stroke();
  });

  // Đai eo kim loại lỏng
  ctx.fillStyle = '#334155';
  ctx.fillRect(0, size * 0.65, size, size * 0.08);
  ctx.fillStyle = '#ffffff';
  ctx.beginPath();
  ctx.arc(size * 0.5, size * 0.69, size * 0.035, 0, Math.PI * 2);
  ctx.fill();
}

export function drawTorso_midas_male(ctx, size, options = {}) {
  const mainColor = options.shirtColor;
  // 39. ÁO CHOÀNG HOÀNG GIA THÊU CHỈ VÀNG VÀ HUY HIỆU THÁI DƯƠNG (AURUM-VEGA - MALE)
  ctx.fillStyle = mainColor || '#d97706';
  ctx.fillRect(0, 0, size, size);

  // Cổ áo hoàng gia vạt chéo
  ctx.fillStyle = options.skinColor || '#f59e0b';
  ctx.beginPath();
  ctx.moveTo(size * 0.35, 0);
  ctx.lineTo(size * 0.5, size * 0.16);
  ctx.lineTo(size * 0.65, 0);
  ctx.closePath();
  ctx.fill();

  // Nẹp viền vàng kim vạt áo chữ V
  ctx.strokeStyle = '#fef08a';
  ctx.lineWidth = size * 0.025;
  ctx.beginPath();
  ctx.moveTo(size * 0.35, 0);
  ctx.lineTo(size * 0.5, size * 0.16);
  ctx.lineTo(size * 0.5, size * 0.65);
  ctx.stroke();

  // Huy hiệu mặt trời vàng ngực áo
  ctx.fillStyle = '#fde047';
  ctx.beginPath();
  ctx.arc(size * 0.5, size * 0.35, size * 0.065, 0, Math.PI * 2);
  ctx.fill();
  ctx.fillStyle = '#b45309';
  ctx.beginPath();
  ctx.arc(size * 0.5, size * 0.35, size * 0.03, 0, Math.PI * 2);
  ctx.fill();

  // Đai hoàng gia vàng kim
  ctx.fillStyle = '#78350f';
  ctx.fillRect(0, size * 0.66, size, size * 0.1);
  ctx.fillStyle = '#fde047';
  ctx.fillRect(size * 0.42, size * 0.67, size * 0.16, size * 0.08);
}

export function drawTorso_midas_female(ctx, size, options = {}) {
  // 40. VÁY DẠ HỘI HOÀNG KIM GIÁC VÀNG QUÝ PHÁI (AURUM-VEGA - FEMALE)
  const midasFGrad = ctx.createLinearGradient(0, 0, 0, size);
  midasFGrad.addColorStop(0, '#b45309');
  midasFGrad.addColorStop(0.5, '#d97706');
  midasFGrad.addColorStop(1, '#f59e0b');
  ctx.fillStyle = midasFGrad;
  ctx.fillRect(0, 0, size, size);

  // Cổ áo cánh sen dát vàng
  ctx.fillStyle = options.skinColor || '#f59e0b';
  ctx.beginPath();
  ctx.ellipse(size * 0.5, 0, size * 0.22, size * 0.15, 0, 0, Math.PI);
  ctx.fill();

  // Họa tiết hoa văn lá vàng uốn lượn
  ctx.strokeStyle = '#fef08a';
  ctx.lineWidth = size * 0.015;
  [0.26, 0.42, 0.56].forEach((yPos) => {
    ctx.beginPath();
    ctx.moveTo(size * 0.2, size * yPos);
    ctx.quadraticCurveTo(size * 0.5, size * (yPos - 0.04), size * 0.8, size * yPos);
    ctx.stroke();
  });

  // Đai eo hoàng tộc
  ctx.fillStyle = '#78350f';
  ctx.fillRect(0, size * 0.64, size, size * 0.08);
  ctx.fillStyle = '#fef08a';
  ctx.beginPath();
  ctx.arc(size * 0.5, size * 0.68, size * 0.04, 0, Math.PI * 2);
  ctx.fill();
}

export const alien_mythic_1_drawers = {
  seraph_male: drawTorso_seraph_male,
  seraph_female: drawTorso_seraph_female,
  lithos_male: drawTorso_lithos_male,
  lithos_female: drawTorso_lithos_female,
  gem_male: drawTorso_gem_male,
  gem_female: drawTorso_gem_female,
  mercury_male: drawTorso_mercury_male,
  mercury_female: drawTorso_mercury_female,
  midas_male: drawTorso_midas_male,
  midas_female: drawTorso_midas_female
};
